<template>
  <v-dialog :value="value" max-width="460" @input="$emit('input', $event)">
    <v-card>
      <v-card-title class="text-h6">{{ $t("print_layout_title") }}</v-card-title>
      <v-card-text class="pb-2">
        <v-btn
          block
          outlined
          color="primary"
          class="print-layout-option mb-3"
          @click="choose('separate')"
        >
          <v-icon left>mdi-file-multiple-outline</v-icon>
          <span class="print-layout-option__text">
            <b>{{ $t("print_layout_separate") }}</b>
            <small>{{ $t("print_layout_separate_hint") }}</small>
          </span>
        </v-btn>
        <v-btn block outlined color="primary" class="print-layout-option" @click="choose('same')">
          <v-icon left>mdi-file-document-outline</v-icon>
          <span class="print-layout-option__text">
            <b>{{ $t("print_layout_same") }}</b>
            <small>{{ $t("print_layout_same_hint") }}</small>
          </span>
        </v-btn>

        <template v-if="branches">
          <div class="print-layout-group">{{ $t("print_layout_branches_title") }}</div>
          <v-btn
            block
            outlined
            color="primary"
            class="print-layout-option mb-3"
            @click="choose('branches')"
          >
            <v-icon left>mdi-source-branch</v-icon>
            <span class="print-layout-option__text">
              <b>{{ $t("print_layout_branches") }}</b>
              <small>{{ $t("print_layout_branches_hint") }}</small>
            </span>
          </v-btn>
          <v-btn block outlined color="primary" class="print-layout-option" @click="choose('sum')">
            <v-icon left>mdi-sigma</v-icon>
            <span class="print-layout-option__text">
              <b>{{ $t("print_layout_sum") }}</b>
              <small>{{ $t("print_layout_sum_hint") }}</small>
            </span>
          </v-btn>
        </template>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('input', false)">{{ $t("cancel") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/**
 * Izbor rasporeda štampe kad izveštaj ima više firmi: svaka firma na posebnom listu ili sve jedna ispod druge
 * na istom listu (za male firme sa 2–3 radnika). Kad neka firma ima poslovnice (`branches`), nude se još dve opcije:
 * poslovnice jedna iza druge na istom listu, ili zbir poslovnica u jednoj tabeli.
 * Emituje `choose` sa "separate" | "same" | "branches" | "sum".
 */
export default {
  name: "PrintLayoutDialog",
  props: {
    value: { type: Boolean, default: false },
    branches: { type: Boolean, default: false },
  },
  methods: {
    choose(layout) {
      this.$emit("input", false);
      this.$emit("choose", layout);
    },
  },
};
</script>

<style scoped>
.print-layout-option {
  height: auto !important;
  min-height: 64px;
  padding: 10px 16px !important;
  justify-content: flex-start;
  text-transform: none;
  letter-spacing: normal;
}

/* Vuetify drži sadržaj dugmeta u jednom redu; opis opcije mora da se lomi unutar dijaloga */
.print-layout-option ::v-deep .v-btn__content {
  flex: 1 1 auto;
  min-width: 0;
  max-width: 100%;
  white-space: normal;
}

.print-layout-option__text {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  white-space: normal;
}

.print-layout-option__text small {
  font-weight: 400;
  opacity: 0.75;
}

.print-layout-group {
  margin: 18px 0 10px;
  padding-top: 12px;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  font-size: 0.8125rem;
  font-weight: 500;
  opacity: 0.75;
}
</style>
